import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton';
import type { UseOrganizationPageHeaderActions } from '@openx/components-organization/lib/utils/context/OrganizationHookTypes';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const useOrganizationPageHeaderActions: UseOrganizationPageHeaderActions = (organizationId: string) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMemo(
    (): ActionButtonProps[] => [
      {
        color: 'secondary',
        'data-test': 'edit-action-button',
        label: t('Edit'),
        onClick: () => {
          navigate(`/organizations/${organizationId}/edit`);
        },
        showAsActionButton: true,
      },
    ],
    [navigate, t, organizationId]
  );
};
